module.exports = __webpack_public_path__ + "img/preview.dce0ab0a.svg";